import {
  LIST_NEW_TYPE_REQUEST,
  LIST_NEW_TYPE_SUCCESS,
  LIST_NEW_TYPE_ERROR,
  RESET_STATE_ALL_APPLICATION,
  RESET_STATE_REDUX
} from '../../actions';

const INIT_STATE = {
  currentNewTypesList: null,
  loading: false,
  success: '',
  error: '',
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case RESET_STATE_ALL_APPLICATION:
      return INIT_STATE;
    case RESET_STATE_REDUX:
      return {
        ...state,
        error: '',
        success: '',
      };
    case LIST_NEW_TYPE_REQUEST:
      return { ...state, loading: true, error: '' };
    case LIST_NEW_TYPE_SUCCESS:
      return {
        ...state,
        loading: false,
        currentNewTypesList: action.payload,
        error: '',
      };
    case LIST_NEW_TYPE_ERROR:
      return {
        ...state,
        loading: false,
        currentNewTypesList: null,
        error: action.payload.message,
      };
    default:
      return { ...state };
  }
};
